// eslint-disable-next-line import/prefer-default-export
export const MAX_YOUTUBE_THUMBNAIL = 'maxresdefault';
